import React from 'react'
import ReactPlayer from "react-player"
import './Stream.css'

function Stream() {
    return (
        <div className="s">
            <h1 className="s-title">Maybe I'm here</h1>
            <ReactPlayer
                url="https://www.twitch.tv/alexlosadac"
                height="90vh" width="100%"
                className="s-item"
            />
        </div>
    )
}

export default Stream